/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import general from '../general/general.functions';

const EstadosLista = ({ show, onValue, errors, register, valueEstado, valueCiudad, multiselect = false }) => {

  let primeraVez = true;
  const estadosr = useRef();
  const ciudadr = useRef();
  const [estados, setEstados] = useState([]);
  const [ciudad, setCiudad] = useState([]);
  const [values, setValues] = useState({
    estado: valueEstado,
    ciudad: valueCiudad,
  })

  useEffect(() => {
    estadosLista();
  },[show]);

  const estadosLista = () => {
    general.estados().then((respuesta) => {
      setEstados(respuesta.estados);
    });
    getCiudad(valueEstado);
  } 

  const getCiudad = (idCiu) => {
    general.ciudades({ estado: idCiu }).then((respuesta) => {
      setCiudad(respuesta.ciudad);
    })
  }

  useEffect(() => {
    setValue(valueEstado);
  },[estados]);

  useEffect(() => {
    if (primeraVez && ciudad.length) {
      let converToArray = Object.keys(ciudadr.current.options);
      converToArray.map((e, i) => {
        if (ciudadr.current.options[e].value === valueCiudad.toString()) {
          ciudadr.current.selectedIndex = i;
        }
      })
      primeraVez = false;
    }
  },[ciudad]); 


  useEffect(() => {
    onValue(values);
  },[values, ciudad])

  const setValue = (value) => {
    let converToArray = Object.keys(estadosr.current.options);
    converToArray.map((e, i) => {
      if (estadosr.current.options[e].value === value.toString()) {
        estadosr.current.selectedIndex = i;
      }
    })
  }

  const setEstadosValue = (id) => {
    getCiudad(id);
    setValues({
      ciudad: 'null',
      estado: parseInt(id),
    })
  }

  const setCiudadValue = (id) => {
    setValues({
      ...values,
      ciudad: parseInt(id),
    })
  } 

  return (
    <>
    <div className="grupo-input">
    <small>Estado</small>
      <select 
        onChange={(e) => setEstadosValue(e.target.value)} 
        className={`form-control input-border ${errors.estado && "is-invalid"}`} 
        name="estado" ref={(e) => { 
          estadosr.current = e;
          register(e, { required: true, validate: value => value !== 'null' })}
        }
        >
        <option value="null">Seleccione...</option>
        {estados.map((estadox) => {
          return <option key={estadox.id} value={estadox.id_estado}>{estadox.estado}</option>
        })}
      </select>
      </div>
       <div className="grupo-input">
       <small>Ciudad</small>
         <select 
           onChange={(e) => setCiudadValue(e.target.value)} 
           className={`form-control input-border ${errors.ciudad && "is-invalid"}`} 
           name="ciudad" ref={(e) => { 
             ciudadr.current = e;
             register(e, { required: true, validate: value => value !== 'null' })}
           }
           >
           <option value="null">Seleccione...</option>
           {ciudad.map((ciudadx) => {
             return <option key={ciudadx.id} value={ciudadx.id_ciudad}>{ciudadx.ciudad}</option>
           })}
         </select>
      </div>
    </>
  )
}

export default EstadosLista;